import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { registerUnauthorizedHandler } from "api/axios";
import authSlice from "./auth/authSlice";
import bidSlice from "./bid/bidSlice";
import sitesSlice from "./sites/sitesSlice";
import installerSlice from "./installer/installerSlice";
import invitesSlice from "./invites/invitesSlice";
import customerSlice from "./customer/customerSlice";
import chatSlice from "./chat/chatSlice";
import { installerLogout } from "./auth/authActions";

const appReducer = combineReducers({
  auth: authSlice,
  bid: bidSlice,
  sites: sitesSlice,
  installer: installerSlice,
  invite: invitesSlice,
  customer: customerSlice,
  chat: chatSlice,
});

const rootReducer = (state, action) => {
  if (action.type === installerLogout.fulfilled.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

registerUnauthorizedHandler(() => store.dispatch(installerLogout()));
